<crm-single-select
  [options]="operators"
  [(selectedItem)]="selectedOperator"
  (selectedItemChange)="selectedOperatorChange.emit($event)"
  [showClear]="showClear"
  [disabled]="disabled"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo">
</crm-single-select>
